import React from 'react';
const RecordSvg = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='17'
      height='22'
      viewBox='0 0 17 22'
      fill='none'
      className={className}
      {...props}
    >
      <path
        d='M12.8429 4.71053C12.8429 2.38512 10.9578 0.5 8.6324 0.5C6.30699 0.5 4.42188 2.38512 4.42188 4.71053V9.97368C4.42188 12.2991 6.30699 14.1842 8.6324 14.1842C10.9578 14.1842 12.8429 12.2991 12.8429 9.97368V4.71053Z'
        fill={color}
      />
      <path
        d='M1.26367 9.97363C1.26367 11.9278 2.03999 13.8021 3.42183 15.1838C4.80368 16.5657 6.67788 17.3421 8.63209 17.3421C10.5863 17.3421 12.4605 16.5657 13.8423 15.1838C15.2242 13.8021 16.0005 11.9278 16.0005 9.97363'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.63184 20.4998V18.3945'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default RecordSvg;
